import {TourGuideClient} from "@sjmc11/tourguidejs";

document.addEventListener("DOMContentLoaded", async () => {
    // Reference: https://tourguidejs.com/
    const startTourButton = document.getElementById('startTourButton');
    const tourElement = document.getElementById('tour');

    if (tourElement) {
        const data = JSON.parse(tourElement.textContent);
        const group = data.title;
        const steps = data.content?.map((step) => ({ ...step, group }));

        const tg = new TourGuideClient({
            completeOnFinish: true,
            dialogZ: 1100,
            backdropClass: "z-index-toast",
            exitOnClickOutside: false,
            steps
        });

         if (startTourButton && steps) {
            startTourButton.addEventListener('click', e => {
                e.preventDefault();
                tg.start(group)
            })
        }
    }
})
